import { Close as CloseIcon } from '@mui/icons-material'
import { ReactElement } from 'react'
import styled from 'styled-components'
import { defaultTheme } from '../../../theme'

interface FilterChipProps {
  label: string
  onRemove: () => void
}

export const FilterChip = ({
  label,
  onRemove,
}: FilterChipProps): ReactElement => (
  <Chip>
    <ChipLabel>{label}</ChipLabel>
    <RemoveButton
      type="button"
      aria-label={`Remove ${label} filter`}
      onClick={onRemove}
    >
      <CloseIcon sx={{ fontSize: 16 }} />
    </RemoveButton>
  </Chip>
)

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 9999px;
  background-color: ${defaultTheme.colors.primaryFadeAlt};
  font-family: Roboto, serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  color: ${defaultTheme.colors.black};

  &:hover {
    background-color: ${defaultTheme.colors.black};
    color: ${defaultTheme.colors.white};

    button {
      color: ${defaultTheme.colors.white};
    }
  }

  &:focus-within {
    outline: 2px dashed ${defaultTheme.colors.black};
    outline-offset: 2px;
  }
`

const ChipLabel = styled.span`
  max-width: 100%;
  overflow-wrap: anywhere;
`

const RemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: inherit;
`
